import dynamic from 'next/dynamic';
import React, { useEffect } from 'react';
import type { ServicePointType } from '../../../../__generated__/globalTypes';
import type { FetchServicePoints_servicePoints_nodes } from '../../../graphql/__generated__/FetchServicePoints';
import { ServicePointDetailCard } from '../../service-points/servicePointDetailCard/servicePointDetailCard';
import { useServiceLocationsContext } from '../../service-points/ServicePoints';

const Map = dynamic(() => import('../../map/Map'));

interface IProps {
  locations: FetchServicePoints_servicePoints_nodes[];
  selectedType: ServicePointType;
  defaultServiceLocation?: FetchServicePoints_servicePoints_nodes;
  isMobile: boolean;
}

export function MapBox({
  defaultServiceLocation,
  locations,
  isMobile,
}: IProps) {
  const { setIsMapOpen, setSelectedServicePoint } =
    useServiceLocationsContext();

  useEffect(() => {
    return () => {
      setSelectedServicePoint?.(undefined);
    };
  }, [setSelectedServicePoint]);

  return (
    <Map
      isMobile={isMobile}
      center={
        defaultServiceLocation
          ? ([
              defaultServiceLocation.longitude,
              defaultServiceLocation.latitude,
            ] as any)
          : undefined
      }
      defaultSelectedLocationId={defaultServiceLocation?.id}
      onClose={() => {
        setIsMapOpen?.(false);
      }}
      markers={[
        {
          popup: (location: any) => (
            <ServicePointDetailCard location={location} />
          ),
          locations: locations as any,
          type: 'branch',
        },
      ]}
    ></Map>
  );
}
